import { connect } from 'react-redux'
import { CHECPLUS_MODULE_TYPES, NEW } from 'utils/constants'
import {
  setFeatureField,
  updateXmcModuleName,
  resetCurrentFeatureMetadata,
} from 'actions/feature/featureMetadata'
import { updateFeatureStatus } from 'actions/feature/features'
import { resetHarnesses } from 'actions/feature/harnesses'
import { getSubGroups } from 'selectors/feature/inputs'
import {
  getFeatureMetadata,
  getFeatureIsValid,
} from 'selectors/feature/featureMetadata'
import { getFunctionLinks } from 'selectors/feature/functions'
import { getIsSameOrgNetwork } from 'selectors/user'
import { getValidationDescriptions } from 'selectors/feature/features'
import { hasRight } from 'selectors/authorization'
import { CREATE_FEATURE } from 'constants/authorization'

import { bindActionCreators } from 'redux'
import { INTERNAL } from 'constants/featureTypes'
import FeatureEditor from './FeatureEditor'

const mapStateToProps = (state) => {
  const featureMetadata = getFeatureMetadata(state)
  const subGroups = getSubGroups(state)
  const functionLinkScraps = getFunctionLinks(state)
  const { moduleType, status, orgId, type, id } = featureMetadata
  const isSameOrg = getIsSameOrgNetwork(state, { orgId })
  const moduleNameIsEditable =
    status === NEW && moduleType === CHECPLUS_MODULE_TYPES.XMC
  const canCreateInternalFeature = hasRight(state, CREATE_FEATURE.INTERNAL)
  const isInternalFeature = type === INTERNAL
  const allDescriptions = getValidationDescriptions(state)

  return {
    ...featureMetadata,
    isSameOrg,
    moduleNameIsEditable,
    subGroups,
    functionLinkScraps,
    isInternalFeature,
    featureId: id,
    featureIsValid: getFeatureIsValid(state),
    allDescriptions,
    canCreateInternalFeature,
  }
}

const mapDispatchToProps = (dispatch) => {
  const setFeatureFieldFromEvent = (fieldName) => (event, featureId) =>
    setFeatureField(fieldName, event.target.value, featureId)
  const setFeatureFieldFromValue = (fieldName) => (value, featureId) =>
    setFeatureField(fieldName, value, featureId)
  return {
    ...bindActionCreators(
      {
        updateDescription: setFeatureFieldFromValue('description'),
        updateMasterNumber: setFeatureFieldFromEvent('masterNumber'),
        updateReleaseNumber: setFeatureFieldFromValue('releaseNumber'),
        updateFeatureType: setFeatureFieldFromEvent('type'),
        updateSubGroup: setFeatureFieldFromValue('subGroup'),
        updateSuccessorCode: setFeatureFieldFromValue('successorCode'),
        updatePriority: setFeatureFieldFromValue('priority'),
        updateModuleName: updateXmcModuleName,
        resetFeature: resetCurrentFeatureMetadata,
        setStatus: updateFeatureStatus,
        resetHarnesses,
      },
      dispatch
    ),
  }
}

const FeatureEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureEditor)

export default FeatureEditorContainer
